import { apiFetch } from './client';

/**
 * TIENDA WEB — los ajustes de la vitrina pública, vistos desde el panel.
 *
 * Todo lo que la tienda dice y cómo se ve vive aquí, en la base: textos,
 * WhatsApp, colores, tipografías y logos. El código de la tienda no lleva
 * nada de ninguna marca.
 */

export interface ColoresDeTienda {
  fondo: string;
  superficie: string;
  realce: string;
  acento: string;
  texto: string;
  tinta: string;
}

export interface FuentesDeTienda {
  titulares: string;
  texto: string;
  firma: string;
  etiquetas: string;
}

export interface ConfigDeTienda {
  activa: boolean;
  lema: string;
  firma: string;
  presentacion: string;
  ubicacion: string;
  lineas: string[];
  promesas: string[];
  historiaTitulo: string;
  historiaTexto: string;
  cierre: string;
  canal: string;
  whatsapp: string;
  instagram: string;
  mostrarPrecios: boolean;
  entregaEnExistencia: string;
  entregaPorEncargo: string;
  colores: ColoresDeTienda;
  fuentes: FuentesDeTienda;
  /** Direcciones ya servibles de los logos; `null` si no se ha subido. */
  emblema: string | null;
  isotipo: string | null;
}

/** Cuántas piezas activas salen en la tienda y cuántas no, por no tener foto o por el tope. */
export interface Vitrina {
  activos: number;
  visibles: number;
  sinFoto: number;
  /** Cuántas piezas enseña la tienda como máximo. */
  tope: number;
  /** Piezas activas que no salen por pasarse del tope (las más viejas). */
  fueraPorTope: number;
}

export type CambiosDeTienda = Partial<
  Omit<ConfigDeTienda, 'emblema' | 'isotipo' | 'colores' | 'fuentes'> & {
    colores: Partial<ColoresDeTienda>;
    fuentes: Partial<FuentesDeTienda>;
  }
>;

export function leerTienda(): Promise<{
  config: ConfigDeTienda;
  vitrina: Vitrina;
  /** El WhatsApp conectado del negocio, en dígitos; `null` si no hay ninguno. Manda sobre el escrito. */
  numeroConectado: string | null;
}> {
  return apiFetch('/api/tienda-web/config');
}

export function guardarTienda(cambios: CambiosDeTienda): Promise<{ config: ConfigDeTienda }> {
  return apiFetch('/api/tienda-web/config', { method: 'PUT', body: cambios });
}

export function subirLogo(
  cual: 'emblema' | 'isotipo',
  archivo: File,
): Promise<{ config: ConfigDeTienda }> {
  const form = new FormData();
  form.append('file', archivo);
  return apiFetch(`/api/tienda-web/logo/${cual}`, { method: 'POST', body: form });
}
